// Mock data for YmaKOOLat Landing Page

export const translations = {
  ro: {
    // Navigation
    nav: {
      home: "Acasă",
      services: "Servicii",
      gallery: "Galerie",
      reviews: "Recenzii",
      contact: "Contact"
    },
    // Hero Section
    hero: {
      title: "Curățare Profesională",
      subtitle: "Canapele & Saltele",
      description: "Servicii profesionale de igienizare pentru canapele și saltele în Brașov și împrejurimi. Echipament profesional și echipă dedicată.",
      ctaPrimary: "Solicită Ofertă",
      ctaSecondary: "Vezi Servicii",
      phone: "+40 779 33 77 20"
    },
    // Services Section
    services: {
      title: "Serviciile Noastre",
      subtitle: "Soluții profesionale de curățare adaptate nevoilor tale",
      couch: {
        title: "Curățare Canapele",
        description: "Curățare profesională și igienizare pentru toate tipurile de canapele. Îndepărtăm petele, mirosurile neplăcute și alergenii.",
        features: [
          "Curățare profundă cu echipament profesional",
          "Îndepărtarea petelor dificile",
          "Eliminarea alergenilor și bacteriilor",
          "Uscare rapidă",
          "Produse ecologice și sigure"
        ]
      },
      mattress: {
        title: "Curățare Saltele",
        description: "Igienizare profesională pentru saltele. Asigurăm un mediu sănătos de somn prin eliminarea acarienilor și bacteriilor.",
        features: [
          "Igienizare profundă anti-acarieni",
          "Eliminarea mirosurilor persistente",
          "Tratamente anti-bacteriene",
          "Fără substanțe chimice nocive",
          "Sistem profesional injecție-extractie"
        ]
      }
    },
    // Gallery Section
    gallery: {
      title: "Galerie Înainte & După",
      subtitle: "Rezultate reale de la clienții noștri",
      before: "Înainte",
      after: "După"
    },
    // Video Section
    video: {
      title: "Procesul Nostru de Curățare",
      subtitle: "Descoperă cum transformăm mobila ta"
    },
    // Reviews Section
    reviews: {
      title: "Ce Spun Clienții Noștri",
      subtitle: "Recenzii reale de pe Google Maps",
      readMore: "Citește mai mult"
    },
    // Coverage Section
    coverage: {
      title: "Zone de Acoperire",
      subtitle: "Servicii profesionale în Brașov și împrejurimi",
      description: "Oferim servicii de curățare profesională în Brașov și zonele limitrofe. Contactează-ne pentru a verifica dacă deservim zona ta!"
    },
    // Contact Section
    contact: {
      title: "Solicită o Ofertă de Preț",
      subtitle: "Prețurile variază în funcție de tipul și starea mobilei. Completează formularul pentru o consultație gratuită.",
      form: {
        name: "Nume complet",
        email: "Email",
        phone: "Telefon",
        service: "Serviciu dorit",
        selectService: "Selectează serviciul",
        couchCleaning: "Curățare Canapele",
        mattressCleaning: "Curățare Saltele",
        both: "Ambele",
        message: "Mesaj (opțional)",
        messagePlaceholder: "Descrie cererea ta...",
        submit: "Trimite Solicitarea",
        submitting: "Se trimite..."
      },
      info: {
        title: "Informații Contact",
        phone: "Telefon",
        email: "Email",
        website: "Website",
        hours: "Program",
        hoursValue: "Luni - Vineri: 08:00 - 20:00 | Sâmbătă: 08:00 - 14:00"
      },
      success: "Mulțumim! Te vom contacta în curând.",
      error: "A apărut o eroare. Te rugăm să încerci din nou."
    },
    // Footer
    footer: {
      description: "Servicii profesionale de igienizare pentru canapele și saltele în Brașov. Echipă dedicată și echipament modern.",
      quickLinks: "Link-uri Rapide",
      contactInfo: "Contact",
      rights: "Toate drepturile rezervate.",
      professional: "Profesioniști în Curățare"
    },
    // Common
    common: {
      requestQuote: "Cere Ofertă",
      learnMore: "Află Mai Mult",
      contactUs: "Sună Acum"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      reviews: "Reviews",
      contact: "Contact"
    },
    // Hero Section
    hero: {
      title: "Professional Cleaning",
      subtitle: "Couches & Mattresses",
      description: "Professional sanitization services for couches and mattresses in Brașov and surrounding areas. Professional equipment and dedicated team.",
      ctaPrimary: "Request Quote",
      ctaSecondary: "View Services",
      phone: "+40 779 33 77 20"
    },
    // Services Section
    services: {
      title: "Our Services",
      subtitle: "Professional cleaning solutions tailored to your needs",
      couch: {
        title: "Couch Cleaning",
        description: "Professional cleaning and sanitization for all types of couches. We remove stains, unpleasant odors, and allergens.",
        features: [
          "Deep cleaning with professional equipment",
          "Removal of tough stains",
          "Elimination of allergens and bacteria",
          "Quick drying",
          "Eco-friendly and safe products"
        ]
      },
      mattress: {
        title: "Mattress Cleaning",
        description: "Professional sanitization for mattresses. We ensure a healthy sleep environment by eliminating dust mites and bacteria.",
        features: [
          "Deep anti-dust mite sanitization",
          "Removal of persistent odors",
          "Anti-bacterial treatments",
          "No harmful chemicals",
          "Professional injection-extraction system"
        ]
      }
    },
    // Gallery Section
    gallery: {
      title: "Before & After Gallery",
      subtitle: "Real results from our clients",
      before: "Before",
      after: "After"
    },
    // Video Section
    video: {
      title: "Our Cleaning Process",
      subtitle: "Discover how we transform your furniture"
    },
    // Reviews Section
    reviews: {
      title: "What Our Clients Say",
      subtitle: "Real reviews from Google Maps",
      readMore: "Read more"
    },
    // Coverage Section
    coverage: {
      title: "Coverage Area",
      subtitle: "Professional services in Brașov and surroundings",
      description: "We offer professional cleaning services in Brașov and neighboring areas. Contact us to check if we serve your area!"
    },
    // Contact Section
    contact: {
      title: "Request a Price Quote",
      subtitle: "Prices vary depending on furniture type and condition. Fill out the form for a free consultation.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone",
        service: "Desired service",
        selectService: "Select service",
        couchCleaning: "Couch Cleaning",
        mattressCleaning: "Mattress Cleaning",
        both: "Both",
        message: "Message (optional)",
        messagePlaceholder: "Describe your request...",
        submit: "Send Request",
        submitting: "Sending..."
      },
      info: {
        title: "Contact Information",
        phone: "Phone",
        email: "Email",
        website: "Website",
        hours: "Hours",
        hoursValue: "Mon - Fri: 08:00 - 20:00 | Sat: 08:00 - 14:00"
      },
      success: "Thank you! We will contact you soon.",
      error: "An error occurred. Please try again."
    },
    // Footer
    footer: {
      description: "Professional sanitization services for couches and mattresses in Brașov. Dedicated team and modern equipment.",
      quickLinks: "Quick Links",
      contactInfo: "Contact",
      rights: "All rights reserved.",
      professional: "Cleaning Professionals"
    },
    // Common
    common: {
      requestQuote: "Request Quote",
      learnMore: "Learn More",
      contactUs: "Contact Us"
    }
  }
};

// Mock Reviews Data - To be replaced with real Google Reviews
export const reviewsData = [
  {
    id: 1,
    name: "Maria Popescu",
    rating: 5,
    date: "2026-03-08",
    text: "Serviciu excepțional! Canapeaua arată ca nouă. Echipa a fost foarte profesionistă și punctuală. Recomand cu încredere!",
    avatar: "MP"
  },
  {
    id: 2,
    name: "Ion Dragoș",
    rating: 5,
    date: "2026-03-01",
    text: "Am solicitat curățarea saltelei și sunt foarte mulțumit de rezultat. Mirosul neplăcut a dispărut complet. Mulțumesc!",
    avatar: "ID"
  },
  {
    id: 3,
    name: "Elena Munteanu",
    rating: 5,
    date: "2026-02-25",
    text: "Profesioniști adevărați! Au reușit să scoată pete foarte vechi de pe canapea. Prețul a fost corect și rezultatul extraordinar.",
    avatar: "EM"
  },
  {
    id: 4,
    name: "Andrei Constantin",
    rating: 5,
    date: "2026-02-18",
    text: "Recomand cu mare drag! Echipament profesional, oameni serioși. Canapeaua și saltelele arată impecabil.",
    avatar: "AC"
  }
];

// Mock Gallery Data - Realistic before/after cleaning photos
export const galleryData = [
  {
    id: 1,
    before: "https://static.prod-images.emergentagent.com/jobs/e82780d4-6c03-49a2-89a1-f21287bc8dc2/images/aaf5b7cedbd76e8b176380267316733727190d4453eb2f04f5922ea030b65fdd.png",
    after: "https://static.prod-images.emergentagent.com/jobs/e82780d4-6c03-49a2-89a1-f21287bc8dc2/images/cf23b5d831521d04bbed18ea03c787de1517b9386758c187b6c4e9ab6eb0df3a.png",
    type: "mattress",
    description: "Saltea cu pată de cafea - curățată în profunzime"
  }
];

// Company Info
export const companyInfo = {
  name: "YmaKOOLat",
  tagline: "Igienizare saltele și canapele",
  phone: "+40 779 33 77 20",
  phoneClean: "40779337720", // pentru WhatsApp (fără spații și +)
  email: "office@ymakoolat.ro",
  website: "www.ymakoolat.ro",
  address: "Mun. Brașov, Strada Lungă nr. 100",
  coverageArea: "Brașov și împrejurimi",
  logo: "https://customer-assets.emergentagent.com/job_ymakoolat-clean/artifacts/v1z3e7zx_Logo%20vectorial.svg",
  googleBusiness: "https://maps.app.goo.gl/KDpYzcSrXc6Jo2eA8",
  googlePlaceId: "ChIJxXqhqgbwl2gRWUhQISbjueg",
  socialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=61588435544209",
    instagram: "https://www.instagram.com/ymakoolat/",
    tiktok: "https://www.tiktok.com/@ymakoolat"
  }
};
